import normalizeLanguage from '../normalizeLanguage';

/**
 * Resolves the initial UI language for a webview from the language the native
 * app injects into `window.nativeLanguage`.
 *
 * Pass the result as the `lng` option to {@link initI18n} so the correct
 * language loads on first paint, instead of initializing in English and
 * switching after mount (which causes a flash and a redundant lazy chunk
 * download). The native value is normalized with {@link normalizeLanguage}
 * (lower-cased, region dropped, `nb`/`nn` mapped to `no`) to match the codes of
 * the bundled translation files.
 *
 * When the native app hasn't injected a language yet — e.g. the bundle
 * evaluated before injection — it falls back to `fallback` (defaults to `'en'`).
 * Apps keep their post-mount `i18n.changeLanguage(...)` call as a safety-net for
 * that case.
 *
 * @param fallback - Language code to use when `window.nativeLanguage` is unset.
 * @returns The normalized initial language code.
 */
const getInitialLanguage = (fallback = 'en'): string =>
  normalizeLanguage(
    (window as { nativeLanguage?: string }).nativeLanguage || fallback,
  );

export default getInitialLanguage;
